import CarrotClient from "../../../lib/carrot-api"
import Settings from "../../../utils/CarrotConfig"
import { useQuery, UseQueryResult, useQueryClient } from "react-query"
import ResponseError from "../../../utils/ResponseError"
import { RetryConfig } from "../../../utils/ErrorHandling"
import { EmployeeConditionAttributes } from "types/Employee"

const client = new CarrotClient(Settings.CARROT_BACKEND_URL)
const ENDPOINT = "GetEmployeeConditionAttributes"

const loadData = async (employeeId: number): Promise<EmployeeConditionAttributes> => {
  return await client.getEmployeeConditionAttributes(employeeId)
}

export const getConditionsCacheKey = (employeeId: number): (string | number)[] => [ENDPOINT, employeeId]

export default function useEmployeeConditionAttributes(
  employeeId: number
): UseQueryResult<EmployeeConditionAttributes, ResponseError> {
  return useQuery<EmployeeConditionAttributes, ResponseError>(
    getConditionsCacheKey(employeeId),
    () => loadData(employeeId),
    {
      ...RetryConfig
    }
  )
}

export function useUpdateEmployeeConditionAttributesCache(
  employeeId: number
): (attributes: EmployeeConditionAttributes) => void {
  const queryClient = useQueryClient()
  return (attributes: EmployeeConditionAttributes) => queryClient.setQueryData([ENDPOINT, employeeId], attributes)
}
